import { portalPageMeta } from "layouts/Admin2/pageMeta";
import PageHeading from "admin/components/PageHeading";
import Admin2 from "layouts/Admin2";
import { UserFilterProvider } from "../UsersFilter/UserFilterContext";
import { DataTable } from "components/PortalDataTable";
import useGetCouriers from "api/UserResource/useGetCouriers";
import Search from "admin/Filters/Search";
import { formData } from "../UsersFilter/userQueryParams";
import ClearFilters from "admin/Filters/ClearFilters";
import useUsersFilters from "../UsersFilter/useUsersFilters";
import { Column } from "primereact/column";
import { useLocation } from "react-router-dom";
import AddCourier from "./AddCourier";
import RemoveCourierPrevilege from "./RemoveCourierPrevilege";

const Couriers = () => {
	const location = useLocation();

	const filters = useUsersFilters();

	const numberOfActiveFilters = filters?.allSearchParams
		?.filter((param) => !filters?.paginationParams?.includes(param))
		?.filter((param) => filters[param] !== "")?.length;

	const { data, isLoading } = useGetCouriers({
		search: filters?.search,
	});

	const users = data?.data?.records;

	const totalRecords = data?.data?.total_records || 0;

	const nameTemplate = (row) => (
		<p className={`flex flex-col `}>
			<span>
				{row.first_name} {row.last_name}
			</span>
			<span className="px-4 py-2 max-w-max rounded-full text-akgreener border border-akgreener text-xs text-center">
				{row?.role_name[0]}
			</span>
		</p>
	);

	const contactDetailsTemplate = (row) => (
		<div className="flex flex-col">
			<span>{row.email}</span>
			{row?.mobile_number && <span>{row.mobile_number}</span>}
		</div>
	);

	// const createdAtTemplate = (row) => <span>{row?.created_at}</span>;

	const Actions = (row) => (
		<div className="flex gap-2 items-center">
			<RemoveCourierPrevilege userId={row?.id} />
		</div>
	);

	return (
		<Admin2
			fullWidth
			breadCrumbs={[
				{
					name: "Users",
					path: "/users/admin/all",
				},
				{
					name: "Couriers",
					path: location.pathname,
				},
			]}
		>
			<UserFilterProvider>
				<div className="flex flex-col w-full ">
					<DataTable
						header={
							<div className="space-y-4 font-sans text-sm w-full px-0">
								<div className="portal-page-actions-row">
									<PageHeading title="Couriers" description={portalPageMeta("/users/admin/couriers").description} count={totalRecords} />

									<AddCourier />
								</div>

								<div className="portal-filter-bar">
									<Search
										filters={filters}
										formData={formData}
										placeholder="Search courier name, email, phone, etc."
									/>
									<ClearFilters
										filters={filters}
										numberOfActiveFilters={numberOfActiveFilters}
									/>
								</div>
							</div>
						}
						loading={isLoading}
						value={users}
						tableClassName="font-sans text-sm w-full"
						dataKey="id"
						autoLayout
					>
						<Column
							header="Full name"
							headerClassName="text-center "
							body={nameTemplate}
						/>

						<Column
							header="Contact details"
							headerClassName="text-center"
							bodyClassName="text-center"
							body={contactDetailsTemplate}
							sortable
						/>
						{/* <Column
							header="Registered on"
							body={createdAtTemplate}
						/> */}
						<Column
							header="Actions"
							body={Actions}
							bodyClassName="text-center"
						/>
					</DataTable>
				</div>
			</UserFilterProvider>
		</Admin2>
	);
};

export default Couriers;
